<div class="volume-viewer">

  @if (showToolbar) {

    <div class="volume-viewer__toolbar">

      <div class="volume-viewer__actions">

        <button
          type="button"
          (click)="fitCamera()"
          [disabled]="status.state !== 'ready'">
          {{ 'volume_viewer_recenter' | transloco }}
        </button>

        <button
          type="button"
          (click)="togglePointCloud()"
          [class.inactive]="!pointCloudVisible">
          {{ 'volume_viewer_point_cloud' | transloco }}
        </button>

        <button
          type="button"
          (click)="toggleDxf()"
          [class.inactive]="!dxfVisible">
          {{ 'volume_viewer_dxf' | transloco }}
        </button>

        <button
          type="button"
          (click)="reload()"
          [disabled]="
            status.state === 'loading' ||
            status.state === 'parsing'
          ">
          {{ 'volume_viewer_reload' | transloco }}
        </button>

      </div>

      <div class="volume-viewer__settings">

        <label class="volume-viewer__setting">

          <span>
            @if (classificationDate2) {
              {{ classificationDate2 | date:'dd/MM/yyyy' }}
            } @else {
              {{ 'volume_viewer_date_2' | transloco }}
            }
          </span>

          <input
            type="color"
            [value]="classificationColor2Hex"
            (input)="onClassificationColor2Change($event)">

        </label>

        <label class="volume-viewer__setting">

          <span>
            @if (classificationDate1) {
              {{ classificationDate1 | date:'dd/MM/yyyy' }}
            } @else {
              {{ 'volume_viewer_date_1' | transloco }}
            }
          </span>

          <input
            type="color"
            [value]="classificationColor1Hex"
            (input)="onClassificationColor1Change($event)">

        </label>

        <label class="volume-viewer__setting">

          <span>
            {{ 'volume_viewer_dxf' | transloco }}
          </span>

          <input
            type="color"
            [value]="lineColorHex"
            (input)="onLineColorChange($event)">

        </label>

        <label
          class="
            volume-viewer__setting
            volume-viewer__setting--width
          ">

          <span>
            {{ 'volume_viewer_line' | transloco }}
          </span>

          <input
            type="range"
            min="1"
            max="10"
            step="0.5"
            [value]="lineWidth"
            (input)="onLineWidthChange($event)">

          <span class="volume-viewer__width-value">
            {{ lineWidth }}
          </span>

        </label>

      </div>

      <div class="volume-viewer__stats">

        @if (pointCount > 0) {
          <span>
            {{ pointCount | number }}
            {{ 'volume_viewer_points' | transloco }}
          </span>
        }

        @if (dxfLineCount > 0) {
          <span>
            {{ dxfLineCount | number }}
            {{ 'volume_viewer_dxf_lines' | transloco }}
          </span>
        }

      </div>

    </div>
  }

  <div
    #viewerContainer
    class="volume-viewer__canvas">
  </div>

  @if (
    status.state === 'loading' ||
    status.state === 'parsing'
    ) {
    <div class="volume-viewer__overlay">

      <div class="volume-viewer__card">

        <div class="volume-viewer__spinner"></div>

        <strong>
          {{ status.message  | transloco }}
        </strong>

      </div>

    </div>
  }

  @if (status.state === 'error') {

    <div class="volume-viewer__overlay">

      <div
        class="
          volume-viewer__card
          volume-viewer__card--error
        ">

        <strong>
          {{ 'volume_viewer_display_error' | transloco }}
        </strong>

        <p>
          {{ status.message }}
        </p>

        <button
          type="button"
          (click)="reload()">
          {{ 'volume_viewer_retry' | transloco }}
        </button>

      </div>

    </div>
  }

</div>
